var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarHeatMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calendar--heat-map_svg__clip0_61530_7416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3h-3V1.5H15V3H9V1.5H7.5V3h-3A1.502 1.502 0 003 4.5v15A1.502 1.502 0 004.5 21h15a1.502 1.502 0 001.5-1.5v-15A1.502 1.502 0 0019.5 3zm-15 1.5h3V6H9V4.5h6V6h1.5V4.5h3v3h-15v-3zm0 4.5h3.75v4.5H4.5V9zm9.75 10.5h-4.5V15h4.5v4.5zm0-6h-4.5V9h4.5v4.5zm1.5 6V15h3.75v4.5h-3.75z",
    fill: "#45464F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendar--heat-map_svg__clip0_61530_7416"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgCalendarHeatMap;